import { Staff } from "../types/Staff";
import { fetchWithAuth } from "../utils/apiUtils";

export default class StaffService {
    private static staffPath = 'identity/users';

    constructor() { }

    public static async getStaff() {
        return await fetchWithAuth(`${this.staffPath}/search`, {
            method: 'POST',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify({}),
        });
    }

    public static async updateStaff(staffId: string, data: Partial<Staff>) {
        return await fetchWithAuth(`${this.staffPath}/${staffId}`, {
            method: 'PATCH',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify(data),
        });
    }

    public static async addStaff(data: Partial<Staff>) {
        return await fetchWithAuth(this.staffPath, {
            method: 'POST',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify(data),
        });
    }

    public static async getStaffById(staffId: string) {
        return await fetchWithAuth(`${this.staffPath}/${staffId}`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async deleteStaff(staffId: string) {
        return await fetchWithAuth(`${this.staffPath}/${staffId}`, {
            method: 'DELETE',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }
}